import {LocaleCode, availableLocales} from '@legit.health/ui';
import i18n from 'i18next';
import Backend, {HttpBackendOptions} from 'i18next-http-backend';
import {initReactI18next} from 'react-i18next';

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

const userLang = navigator.language || LocaleCode.English;
const defaultLocale = availableLocales.map((l) => l.code as string).includes(userLang)
  ? userLang
  : LocaleCode.English;

const searchParams = new URLSearchParams(window.location.search);
let searchParamsLocale = searchParams.get('locale')?.replaceAll('_', '-');
if (searchParamsLocale === 'es') {
  searchParamsLocale = 'es-ES';
} else if (searchParamsLocale === 'en') {
  searchParamsLocale = 'en-GB';
}

const locale = searchParamsLocale ?? defaultLocale;

i18n
  .use(initReactI18next)
  .use(Backend)
  .init<HttpBackendOptions>({
    returnNull: false,
    lng: locale,
    interpolation: {
      escapeValue: false
    },
    fallbackLng: false,
    ns: ['ui', 'app'],
    backend: {
      queryStringParams: {v: '2.0.0'}
    }
  });

export default i18n;
